module.exports = __webpack_public_path__ + "static/media/icon-translation.1caefa24.svg";